export const CouldNotConnectToAccountTitleText = "Hkc";
export const MailMessageFileProviderDisplayName = "Ikc";
export default {CouldNotConnectToAccountTitleText,MailMessageFileProviderDisplayName};